import React, { FC, useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import NoProjectsIcon from '../assets/NoProjectsIcon'
import ProjectContentsTable from '../components/table/ProjectContentsTable'
import ProjectService, { Project } from '../services/ProjectService'

const SearchResultsPage: FC = () => {
  const { org } = useParams()
  const { t } = useTranslation()
  //const { data: files, isLoading: isFilesLoading } = useProjectContent()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [searchResults, setSearchResults] = useState<Project[]>([])
  const query = searchParams.get('query')

  useEffect(() => {
    if (query)
      ProjectService.getSearchResults(org!, query!).then((res) =>
        setSearchResults(
          res.result.map((item) => {
            return { name: item.name, lastModified: item.lastModified, totalSize: item.totalSize }
          }),
        ),
      )
  }, [query, org])

  const headers = [
    {
      accessor: 'name',
      label: t('name'),
    },
    {
      accessor: 'lastModified',
      label: t('modified'),
    },
    {
      accessor: 'totalSize',
      label: t('size'),
    },
    {
      accessor: 'actions',
      label: t('actions'),
    },
  ]

  return (
    <div className='h-full w-full flex overflow-auto'>
      <div className='h-full w-full'>
        <div className='w-full h-[60px] flex justify-start border-b border-gray-300 items-center px-8'>
          <button onClick={() => navigate(-1)} className='rounded-full hover:bg-sky-50 p-2 mr-4'>
            <ArrowLeftIcon className='w-6 h-6 text-gray-400' />
          </button>
          <p>Search results</p>
        </div>
        {/* {isFilesLoading && (
          <div className='w-full flex justify-center pt-5'>
            <SpinnerIcon className='text-sky-500 h-7 w-7'></SpinnerIcon>
          </div>
        )} */}
        {
          // !isFilesLoading &&
          searchResults.length === 0 ? (
            <div className='flex flex-col h-1/2 w-full mx-auto mt-14 items-center justify-start'>
              <NoProjectsIcon className='text-white fill-slate-400 w-20 h-20' />
              <p className='text-slate-400 font-medium'>{t('nothingFound')}</p>
            </div>
          ) : (
            <div className='py-6'>
              <ProjectContentsTable headers={headers} rows={searchResults || []} />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default SearchResultsPage
